import { render } from "./CreateSong.vue?vue&type=template&id=563f9c36"
import script from "./CreateSong.vue?vue&type=script&lang=js"
export * from "./CreateSong.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__